import React, { Component } from "react";
import PropTypes from "prop-types";

import i18n from "i18n-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withRouter, Redirect } from "react-router-dom";

import { Progress } from "C4";

const chapterImageSrc = (src, appId) => {
  if (!src) return "";
  const imgExt = ["jpg", "png", "bmp"].some((ext) => src.includes(`.${ext}`));
  if (!src.includes("http") && imgExt) {
    return `https://travprocdn.imgix.net/${appId}/${src}?width=500`;
  }
  return src;
};

const Overlay = (props) => {
  const { id } = props;
  return (
    <div id={`overlay_${id}`} className="overlay">
      <i id={`lock_${id}`} className="fas fa-lock" />
    </div>
  );
};

class TrainingCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: "",
    };
  }

  redirect(url, page, path) {
    const { redirPath, history } = this.props;
    if (page === undefined) {
      history.push(`${path !== undefined ? path : redirPath}${url}/0`);
    } else {
      history.push(`${path !== undefined ? path : redirPath}${url}/${page}`);
    }
  }

  render() {
    const {
      appId,
      chapter,
      chapterCount,
      chaptersProgress,
      history,
      index,
      locked,
      lockedSubtitle,
      foundation,
      // lockedSubtitleRedirect,
      redirPath,
      comingSoon,
    } = this.props;

    const { chapterImage, chapterID, chapterTitle, badge } = chapter;

    const { redirect } = this.state;

    let buttonText;
    let redir;
    switch (chaptersProgress.percentage) {
      case 100:
        buttonText = i18n.translate("trainingScreens.restart");
        redir = () => {
          history.push(`${redirPath}${chapterID}/0`);
        };
        break;
      case undefined:
      case 0:
        buttonText = i18n.translate("trainingScreens.start");
        break;
      default:
        buttonText = i18n.translate("trainingScreens.continue");
    }

    if (redirPath.includes("/main/ret/chapter/")) {
      buttonText = i18n.translate("trainingScreens.review");
    }

    if (redir === undefined) {
      redir = (path) => {
        this.redirect(chapterID, chaptersProgress.last_page, path);
      };
    }

    return (
      <div className="holderTrain">
        {chaptersProgress.percentage === 100 && badge && !comingSoon && (
          <div className="badge">
            <a
              href={`https://stack.travpromobile.com/download.php?url=${badge}`}
            >
              <FontAwesomeIcon
                icon={["far", "file-certificate"]}
                className="badgeItem"
              />
              <br />
              <span>{i18n.translate("trainingScreens.badge")}</span>
            </a>
          </div>
        )}

        <div
          role="button"
          tabIndex={index}
          onKeyPress={() => {
            redir();
          }}
          onClick={() => {
            redir();
          }}
          className={`trainingCard ${locked ? "locked" : ""}`}
        >
          <div className="textContainer">
            <div>
              {comingSoon && <h4>Coming Soon: {chapterTitle}</h4>}
              {!comingSoon && <h3>{chapterTitle}</h3>}
              <div className="line" />
              {!locked && (
                <p className="duration">
                  <FontAwesomeIcon icon={["far", "clock"]} />
                  {` ${chapterCount} ${i18n.translate("trainingScreens.durationInMinutes")}`}
                </p>
              )}
              {!locked && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    redir(redirPath);
                  }}
                >
                  {buttonText}
                </button>
              )}
              {lockedSubtitle && foundation && locked && !comingSoon && (
                <p>
                  {i18n.translate("trainingScreens.unlockFoundation", {
                    number: index + 1,
                  })}
                </p>
              )}
              {!lockedSubtitle && foundation && locked && !comingSoon && (
                <p>
                  {i18n.translate("trainingScreens.unlockFoundation", {
                    number: index,
                  })}
                </p>
              )}
              {lockedSubtitle && !foundation && locked && !comingSoon && (
                <p>{lockedSubtitle}</p>
              )}
              {!lockedSubtitle && !foundation && locked && !comingSoon && (
                <React.Fragment>
                  <p>
                    {i18n.translate("trainingScreens.unlockSpecialization")}
                  </p>
                  <FontAwesomeIcon icon={["fas", "lock"]} />
                </React.Fragment>
              )}
            </div>
          </div>
          <div className="imageContainer">
            <img
              src={chapterImageSrc(chapterImage, appId)}
              alt={chapterTitle || ""}
            />
            <div
              id={`card_gradient_${chapterID}_${index}`}
              className="overlay gradient"
            />
            {locked && <Overlay id={index} />}
            <span className="chapterNumber">{`0${index + 1}`.slice(-2)}</span>
            <span className="chapterComplete">
              {chaptersProgress.percentage === 100 && !locked && (
                <FontAwesomeIcon
                  icon={["far", "check-circle"]}
                  className="chapterComplete"
                />
              )}
            </span>
          </div>
          {!locked && (
            <Progress id={index} value={chaptersProgress.percentage} />
          )}
          {!locked && redirect.length > 0 && <Redirect to={redirect} />}
        </div>
      </div>
    );
  }
}

export default withRouter(TrainingCard);

TrainingCard.propTypes = {
  appId: PropTypes.number.isRequired,
  chapter: PropTypes.shape({
    chapterID: PropTypes.string,
    chapterImage: PropTypes.string,
    chapterImagePro: PropTypes.string,
    chapterItemCount: PropTypes.number,
    chapterNumber: PropTypes.string,
    chapterTitle: PropTypes.string,
    badge: PropTypes.string,
  }).isRequired,
  chapterCount: PropTypes.number,
  chaptersProgress: PropTypes.shape({
    chapter: PropTypes.string,
    last_page: PropTypes.number,
    percentage: PropTypes.number,
    progress: PropTypes.number,
    total_pages: PropTypes.number,
  }),
  history: PropTypes.shape().isRequired,
  index: PropTypes.number.isRequired,
  locked: PropTypes.bool,
  comingSoon: PropTypes.bool,
  lockedSubtitle: PropTypes.string,
  // lockedSubtitleRedirect: PropTypes.string,
  redirPath: PropTypes.string,
  foundation: PropTypes.bool.isRequired,
};

TrainingCard.defaultProps = {
  chapterCount: 0,
  chaptersProgress: {},
  locked: false,
  redirPath: "/main/training/chapter/",
  lockedSubtitle: null,
  comingSoon: false,
  // lockedSubtitleRedirect: '',
};

Overlay.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};
